const VOWEL_GROUPS = {
  a: 'ı',
  ı: 'ı',
  e: 'i',
  i: 'i',
  o: 'u',
  u: 'u',
  ö: 'ü',
  ü: 'ü',
};

export function withTurkishGenitive(value) {
  const name = String(value || '').trim();
  if (!name) return '';

  const normalizedName = name.toLocaleLowerCase('tr-TR');
  const vowels = [...normalizedName].filter((character) => VOWEL_GROUPS[character]);
  const harmonyVowel = VOWEL_GROUPS[vowels[vowels.length - 1]] || 'i';
  const lastCharacter = normalizedName[normalizedName.length - 1];
  const bufferConsonant = VOWEL_GROUPS[lastCharacter] ? 'n' : '';

  return `${name}'${bufferConsonant}${harmonyVowel}n`;
}
